export const companySearch = 'admin/app/company/search';
export const yandexapiCheck = 'admin/yandex/api/check';
export const bankSearch = 'admin/billing/bank/search';
export const autoModel = 'admin/app/auto/model';
export const autoMark = 'admin/app/auto/mark';
export const fileUpload = '/file/upload';
export const errortrackingNew = 'admin/ext/errortracking/new';
export const investProfileNicknameAvailable = 'admin/app/investor_platform_profile/is_nickname_available';
